import { Component, inject, input, OnInit, output, signal } from '@angular/core';
import { ColDef, GridOptions } from 'ag-grid-community';
import { Subject } from 'rxjs';
import { defaultTableDefOptions } from '../../helpers';
import { SubscriptionService } from '../../service/subscription.service';
import { BranchImpl, BundleSummary } from '../../types';

@Component({
  selector: 'app-bundle-summary-purchase',
  templateUrl: './bundle-summary-purchase.component.html',
  styleUrls: ['./bundle-summary-purchase.component.scss'],
  standalone: false,
})
export class BundleSummaryPurchaseComponent implements OnInit {
  private subscriptionService = inject(SubscriptionService);

  readonly branch = input<BranchImpl>(undefined);
  readonly triggerBundleRefresh = input<Subject<boolean>>(undefined);
  readonly bundleSummaryUpdated = output<BundleSummary[]>();

  isLoading = signal<boolean>(false);
  summary = signal<BundleSummary[]>([]);

  public readonly tableDef: GridOptions<BundleSummary> = {
    ...defaultTableDefOptions(),
    pagination: true,
    paginationPageSize: 10,
    paginationPageSizeSelector: [10, 20, 50],
  };

  public readonly columnDefs: ColDef<BundleSummary>[] = [
    {
      field: 'bundle',
      headerName: 'Bundle',
      cellDataType: 'text',
      filter: 'agTextColumnFilter',
    },
    {
      field: 'total_quantity',
      headerName: 'Total',
      cellDataType: 'number',
      filter: 'agNumberColumnFilter',
    },
    {
      field: 'assigned',
      headerName: 'Assigned',
      cellDataType: 'number',
      filter: 'agNumberColumnFilter',
    },
  ];

  refreshBundleSummary() {
    this.isLoading.set(true);
    this.subscriptionService.getBundleSummary(this.branch().id).subscribe({
      next: (res) => {
        this.summary.set(res);
        this.bundleSummaryUpdated.emit(res);
      },
      complete: () => {
        this.isLoading.set(false);
      },
    });
  }

  ngOnInit(): void {
    this.refreshBundleSummary();
    this.triggerBundleRefresh().subscribe({
      next: () => {
        this.refreshBundleSummary();
      },
    });
  }
}
